var map = {
	"./A-Relic Frame.png": 3944,
	"./A-Relic Recipe.png": 9052,
	"./A.png": 7900,
	"./B-Relic Frame.png": 1373,
	"./B-Relic Recipe.png": 5651,
	"./B.png": 1819,
	"./C-Relic Frame.png": 3452,
	"./C-Relic Recipe.png": 8321,
	"./C.png": 6905,
	"./D-Relic Frame.png": 7830,
	"./D.png": 1825,
	"./S-Relic Frame.png": 9647,
	"./S-Relic Recipe.png": 1828,
	"./S.png": 2800,
	"./SS-Relic Frame.png": 670,
	"./SS-Relic Recipe.png": 6321,
	"./SS.png": 9057,
	"./jade.png": 5981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6447;